import { useCallback, useEffect, useState } from 'react';
import { ExternalSalesApiError, fetchCampaign } from '../../api/externalSalesApi';
import { Campaign } from '../../api/types';

export type CampaignState =
  | { kind: 'loading' }
  | { kind: 'loaded'; campaign: Campaign }
  | { kind: 'empty' }
  | { kind: 'error' };

export type UseCampaignResult = {
  state: CampaignState;
  reload: () => void;
};

export function useCampaign(campaignCode: string): UseCampaignResult {
  const [state, setState] = useState<CampaignState>({ kind: 'loading' });
  const [attempt, setAttempt] = useState(0);

  const reload = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    let active = true;
    setState({ kind: 'loading' });

    fetchCampaign(campaignCode)
      .then((campaign) => {
        if (active) {
          setState({ kind: 'loaded', campaign });
        }
      })
      .catch((error: unknown) => {
        if (!active) {
          return;
        }
        const notFound = error instanceof ExternalSalesApiError && error.status === 404;
        setState(notFound ? { kind: 'empty' } : { kind: 'error' });
      });

    return () => {
      active = false;
    };
  }, [campaignCode, attempt]);

  return { state, reload };
}
